define('Components/TitleWidget/js/views/TitleWidgetInstanceView',['jquery','WidgetInstanceView','template!Components/TitleWidget/templates/test','template!Components/TitleWidget/templates/test2',
        'template!Components/TitleWidget/templates/center', 'template!Components/TitleWidget/templates/fidelity', 'template!Components/TitleWidget/templates/account'
    ],
    function($,WidgetInstanceView,testTemplate,test2Template, centerTemplate, fidelityTemplate, accountTemplate){
    return WidgetInstanceView.extend({
        name:'TitleWidgetInstanceView',
        getTemplate:function(){
            switch(this.model.getTemplate()){

                case "center": return centerTemplate; break;
                case "account": return accountTemplate; break;
                case 'test': default: return testTemplate; break;
                case "test2": return test2Template; break;
                case "fidelity": return fidelityTemplate; break;
            }
        },
    })
});
